import { render, staticRenderFns } from "./male.vue?vue&type=template&id=240aae8c&scoped=true&"
var script = {}
import style0 from "./male.vue?vue&type=style&index=0&id=240aae8c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "240aae8c",
  null
  
)

export default component.exports